module.exports = __webpack_public_path__ + "media/images/pages/team-6-48dd5d845ef0ef47107fc72e0ef9b55a.jpg";